import { createSlice } from '@reduxjs/toolkit';

import { handleGetAthleteRoles } from './actions';
import { IAthleteRolesState } from './slice.interface';

const initialState: IAthleteRolesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const athleteRolesSlice = createSlice({
  name: 'athlete-roles',
  initialState,
  reducers: {
    removeAthleteRoles: (state: IAthleteRolesState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAthleteRoles.pending, (state: IAthleteRolesState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAthleteRoles.rejected, (state: IAthleteRolesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAthleteRoles.fulfilled, (state: IAthleteRolesState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeAthleteRoles } = athleteRolesSlice.actions;

export default athleteRolesSlice.reducer;
